export default "__VITE_ASSET__CkGZyEth__"